import { render, staticRenderFns } from "./courseTag.vue?vue&type=template&id=5a2ec9ef&scoped=true&"
import script from "./courseTag.vue?vue&type=script&lang=js&"
export * from "./courseTag.vue?vue&type=script&lang=js&"
import style0 from "./courseTag.vue?vue&type=style&index=0&id=5a2ec9ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ec9ef",
  null
  
)

export default component.exports